import React from 'react';

import Select from 'components/shared/Select/Select';

import {
  addressFormats,
  currencyFormats,
  dateFormats,
  nameFormatOptions
} from '../lib/importFormats';

const getHint = (headerValue, patientDetailsFormat) => {
  switch (headerValue?.value) {
    case 'dob':
      return !patientDetailsFormat?.dobFormat?.value ? 'Select a DOB format' : null;
    case 'name':
      return !patientDetailsFormat?.patientName?.value ? 'Select a name format' : null;
    case 'insurance_policy_start_date':
      return !patientDetailsFormat?.policyStartDateFormat?.value
        ? 'Select a policy start date format'
        : null;
    case 'insurance_policy_end_date':
      return !patientDetailsFormat?.policyEndDateFormat?.value
        ? 'Select a policy end date format'
        : null;
    case 'appointment_provider':
      return !patientDetailsFormat?.providerName?.value ? 'Select a name format' : null;
    case 'transaction_amount':
      return !patientDetailsFormat?.transactionAmountFormat?.value
        ? 'Select a currency format'
        : null;
    case 'transaction_amount_paid_self':
      return !patientDetailsFormat?.transactionAmountSelfFormat?.value
        ? 'Select a currency format'
        : null;
    default:
      return headerValue?.message || '';
  }
};

const ImportSelectItem = ({
  headerValue,
  patientDetailsFormat,
  columnHeaderOptions,
  onChangeHandler,
  handleHeaderSelect,
  index,
  refs
}) => (
  <div style={{ minWidth: '12rem' }}>
    {getHint(headerValue, patientDetailsFormat) && (
      <span className="m-1 rounded-md border-none bg-danger-200 p-1.5 text-black">
        {getHint(headerValue, patientDetailsFormat)}
      </span>
    )}
    <div className="flex flex-col gap-2">
      <Select
        isClearable
        options={columnHeaderOptions}
        onChange={(e) => handleHeaderSelect(e, index)}
        value={headerValue || null}
      />
      {headerValue?.value === 'full_street_address' && (
        <Select
          isClearable
          value={patientDetailsFormat?.addressFormat}
          options={addressFormats}
          onChange={(e) => onChangeHandler(e, 'addressFormat', refs.addressFormatRef, index)}
          placeholder="Enter how the address appears"
          required
        />
      )}
      {headerValue?.value === 'dob' && (
        <Select
          isClearable
          value={patientDetailsFormat?.dobFormat}
          options={dateFormats}
          onChange={(e) => onChangeHandler(e, 'dobFormat', refs.dobFormatRef, index)}
          placeholder="Enter how the date of birth appears"
          required
        />
      )}
      {headerValue?.value === 'name' && (
        <Select
          isClearable
          value={patientDetailsFormat?.patientName}
          options={nameFormatOptions}
          onChange={(e) => onChangeHandler(e, 'patientName', refs.nameFormatRef, index)}
          placeholder="Enter the name order"
          required
        />
      )}
      {headerValue?.value === 'insurance_policy_start_date' && (
        <Select
          isClearable
          value={patientDetailsFormat?.policyStartDateFormat}
          options={dateFormats}
          onChange={(e) =>
            onChangeHandler(e, 'policyStartDateFormat', refs.policyStartDateFormatRef, index)
          }
          placeholder="Enter how the policy start date appears"
          required
        />
      )}
      {headerValue?.value === 'insurance_policy_end_date' && (
        <Select
          isClearable
          value={patientDetailsFormat?.policyEndDateFormat}
          options={dateFormats}
          onChange={(e) =>
            onChangeHandler(e, 'policyEndDateFormat', refs.policyEndDateFormatRef, index)
          }
          placeholder="Enter how the policy end date appears"
          required
        />
      )}
      {headerValue?.value === 'appointment_provider' && (
        <Select
          isClearable
          value={patientDetailsFormat?.providerName}
          options={nameFormatOptions}
          onChange={(e) => onChangeHandler(e, 'providerName', refs.providerNameFormatRef, index)}
          placeholder="Enter the name order"
          required
        />
      )}
      {headerValue?.value === 'transaction_amount' && (
        <Select
          isClearable
          value={patientDetailsFormat?.transactionAmountFormat}
          options={currencyFormats}
          onChange={(e) =>
            onChangeHandler(e, 'transactionAmountFormat', refs.transactionAmountFormatRef, index)
          }
          placeholder="Enter the currency format"
          required
        />
      )}
      {headerValue?.value === 'transaction_amount_paid_self' && (
        <Select
          isClearable
          value={patientDetailsFormat?.transactionAmountSelfFormat}
          options={currencyFormats}
          onChange={(e) =>
            onChangeHandler(
              e,
              'transactionAmountSelfFormat',
              refs.transactionAmountSelfFormatRef,
              index
            )
          }
          placeholder="Enter the currency format"
          required
        />
      )}
    </div>
  </div>
);

export default ImportSelectItem;
